import React from 'react';
import useIsMobile from '../Hooks/useIsMobile';
import SpecificationTabsDesktop from './ProductPage/SpecificationTabsDesktop';
import SpecificationTabsMobile from './ProductPage/SpecificationTabsMobile';

const ProductSpecificationArea = (props) => {
  const productSpecifications = props;
  const isMobile = useIsMobile();

  return (
    <>
      {isMobile ? (
        <SpecificationTabsMobile
          productSpecifications={productSpecifications}
          isB2b={props.isB2b}
          showProductShippingInformation={props.showProductShippingInformation}
        />
      ) : (
        <SpecificationTabsDesktop
          productSpecifications={productSpecifications}
          isB2b={props.isB2b}
          showProductShippingInformation={props.showProductShippingInformation}
        />
      )}
    </>
  );
};

export default ProductSpecificationArea;
